import Vue from 'vue'
import App from './App.vue'
import Trend from 'vuetrend'
import router from './router'
import store from './store'
import './registerServiceWorker'
import * as _ from 'lodash'
import numeral from 'numeral'
import VueApexCharts from 'vue-apexcharts'
import draggable from 'vuedraggable'
import FormatUtils from './utils/format-utils'
import { getRelativeDate } from './utils/date-utils'
import './polyfills';
import CurrencyVisualizer from "./components/selection-visualizers/CurrencyVisualizer"
import AccountVisualizer from "./components/selection-visualizers/AccountVisualizer"
import VCalendar from 'v-calendar';
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueMarkdown from 'vue-markdown'
import moment from 'moment'
import { LMap, LTileLayer, LMarker, LCircle } from 'vue2-leaflet'
import VueI18n from 'vue-i18n';
import cs from './i18n/cs'
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

library.add(far)
library.add(fal)
library.add(fad)
library.add(fas)

Vue.component('vue-markdown', VueMarkdown);
Vue.component('icon', FontAwesomeIcon)
Vue.component('icon-layers', FontAwesomeLayers)
Vue.component('icon-layers-text', FontAwesomeLayersText)
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
Vue.use(Notifications);

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-circle', LCircle);

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
    componentPrefix: 'v',  // Use <vc-calendar /> instead of <v-calendar />
});
Vue.use(VueI18n)
Vue.use(VModal, {componentName: 'v-modal'});
const messages = {
    cs
}
const i18n = new VueI18n({
    locale: "cs",
    messages
});

Vue.use(Trend);
Vue.use(VueApexCharts);
Vue.component('apex-chart', VueApexCharts);
Vue.component('draggable', draggable);

//Vue.prototype.$axios =
Vue.prototype.$_ = _;
Vue.prototype.$moment = moment;
Vue.prototype.$numeral = numeral;
Vue.prototype.$formats = FormatUtils();
//TODO: Move to utils
Vue.prototype.$tableSort = (sort, tableEntries, tableConfig) => {
    return [...tableEntries].sort((a, b) => {
        [a, b] = sort.direction == 'ASC' ? [a, b] : [b, a];
        let column = tableConfig.columns.find(col => col.sortField == sort.sortField);
        if (column.sortType == 'number') {
            let valueHandler = column.datum;
            if(column.raw) {
                valueHandler = column.raw;
            }
            return +valueHandler(a) - valueHandler(b)
        } else if (column.sortType == 'date') {
            return column.datum(a).getTime() - column.datum(b).getTime()
        } else {
            return String(column.datum(a)).localeCompare(column.datum(b))
        }

    })
}
Vue.prototype.customRenderers = {
    CurrencyVisualizer,
    AccountVisualizer
};

numeral.localeData().delimiters.thousands = ' ';

Vue.config.productionTip = false;

Vue.prototype.pushTheme = (theme) => {
    const root = document.documentElement;
    Object.keys(theme).forEach(themeKey => root.style.setProperty(themeKey, theme[themeKey]));
};

const socket = new SockJS('notification/notification-messages');
const stomp = Stomp.over(socket);

Vue.prototype.socket = socket;
Vue.prototype.stompClient = stomp;
Vue.prototype.convertRelativeDate = getRelativeDate;
Vue.prototype.$eventBus = new Vue();

let vue = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

export { i18n }
